import React, { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash-es';
import classNames from 'classnames';
import Button from 'reactstrap/lib/Button';
import { Spinner } from 'site-modules/shared/components/spinner/spinner';
import { ENTER_KEY_VALUE } from 'site-modules/shared/constants/key-values';

import './private-party-button.scss';

export function PrivatePartyButton({
  onClick = noop,
  isSubmitting = false,
  isActiveTab = false,
  isDisabled = false,
  buttonClassName = '',
}) {
  const onKeyPress = useCallback(
    event => {
      const { key } = event;

      if (key === ENTER_KEY_VALUE && isActiveTab) {
        onClick(event);
      }
    },
    [isActiveTab, onClick]
  );

  useEffect(() => {
    window.addEventListener('keydown', onKeyPress);

    return () => {
      window.removeEventListener('keydown', onKeyPress);
    };
  }, [onKeyPress]);

  return (
    <Button
      color="blue-50"
      className={classNames(
        'private-party-btn btn-responsive-md-down text-transform-none d-flex align-items-center justify-content-center ',
        buttonClassName
      )}
      onClick={onClick}
      disabled={isDisabled}
      data-testid="private-party-btn"
    >
      {isSubmitting && (
        <span className="pe-0_5">
          <Spinner size={14} thickness={1} color="white" />
        </span>
      )}
      <span className="size-16">List my car for sale</span>
    </Button>
  );
}

PrivatePartyButton.propTypes = {
  onClick: PropTypes.func,
  isSubmitting: PropTypes.bool,
  isActiveTab: PropTypes.bool,
  isDisabled: PropTypes.bool,
  buttonClassName: PropTypes.string,
};
